<template>
  <div class="cat-file">
    <div class="fileboxheader">
      <span>{{ headert }}</span>
      <img 
        style="width:20px;height:20px" 
        src="@/assets/preview_file.png" 
        @click="preview"
      />
    </div>
    <div class="fileboxmain">
      <div class="fileboxbox">
        <img class="img" :src="require(`@/assets/fileExample/${imgName}.jpg`)" alt="" />
      </div>
    </div>
    <q-image-view v-if="previewFlag" :imgName="imgName" @close="close"></q-image-view>
  </div>
</template>

<script>
import QImageView from '@/components/imageView.vue'
export default {
  name: "CatInput",
  components: {
    QImageView
  },
  props: {
    headert: {
      type: String,
      default: '示例'
    },
    imgName: {
      type: String,
      default: 'certificate'
    }
  },
  data() {
    return {
      previewFlag: false,
      previewUrl:'',
      destoryFlag: false
    }
  },
  methods: {
    upclick() {
      this.$emit("bindup");
    },
    testclick() {
      this.$emit("codeclick");
    },
    handleinput(event) {
      //父组件在绑定v-model时，其实就绑定的input事件，因此父组件不需要再声明事件了
      this.$emit("input", event.target.value);
    },
    clear() {
      this.$emit("input", "");
    },
    preview() {
      this.previewFlag = true
    },
    close() {
      this.previewFlag = false
    }
  }
}
</script>
<style lang="less" scoped>
.fileboxheader {
  position: relative;
  width: @fileboxw;
  height: @filebox;
  line-height: @filebox;

  border: @filexborder;
  background: @bluebtn;
  > span {
    color: @whitee;
    padding-left: @filepadding;
  }
  > img {
    position: absolute;
    right: @filepadding;
    top: 50%;
    width: @checkringht;
    transform: translateY(-50%);
  }
}
.fileboxmain {
  background: @globalback;
  width: @fileboxw;
  height: @fileboxmax;
  border: @filexborder;

  display: flex;
  justify-content: center;
  align-items: center;
}
.fileboxbox {
  display: flex;
  width: 100px;
  justify-content: center;
  align-content: center;
}

.fileboxtext {
  color: @bluebtn;
  font-size: @checkringht;
}

.img{
  width: 63PX;
  height: 88PX;

}
</style>
